<template>
    <div class="wrapper">
        <h2>Ios specific settings</h2>

        <section>
            <h4>Input Container</h4>
            <div class="row">
                <custom-input name="iOSInputContainerBackgroundColor" ref="iOSInputContainerBackgroundColor" label="Background color iOS" type="colorpicker" v-model="settings.iOSInputContainerBackgroundColor" />
                <help-popover>
                    <template slot="content">
                        <p>The color of the bottom bar on iOS which contains the text field and the send & picture buttons</p>
                    </template>
                </help-popover>
            </div>
        </section>

        <section>
            <h4>Status Bar</h4>
            <div class="row">
                <custom-input name="iOSStatusBarTextColor" ref="iOSStatusBarTextColor" label="Text color" type="colorbuttons" :colors="StatusBarTextColor" v-model="settings.iOSStatusBarTextColor" />
                <help-popover>
                    <template slot="content">
                        <p>The text color for the statusbar in iOS</p>
                    </template>
                </help-popover>
            </div>
        </section>
    </div>
</template>

<script>
import { Default } from '@/mixins/mixins';
import customInput from '@/components/additional/customInput.vue';
import HelpPopover from '../../additional/helpPopover';

export default {
    name: 'appearanceIos',
    mixins: [
        Default
    ],
    components: { HelpPopover, customInput },
    props: ['settings'],
    data() {
        return {
            StatusBarTextColor: {
                0: 'white',
                1: 'black'
            }
        };
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>
